

















import { Component, Prop, Vue } from 'vue-property-decorator'

import { Invoice } from '@/models'

@Component
export default class CustomerInfo extends Vue {
  @Prop({ type: Object, required: true })
  readonly invoice!: Invoice

  get address () {
    if (!this.invoice.address) {
      return null
    }

    const address = this.invoice.address

    return [
      address.complement !== null
        ? `${address.street}, ${address.number} - ${address.complement}`
        : `${address.street}, ${address.number}`,
      address.neighborhood,
      `${address.city}/${address.district}`,
      address.cep
    ].filter((a) => a !== null).join(', ')
  }

  get customerInfo () {
    return [
      {
        icon: 'person',
        text: this.invoice.name
      },
      {
        icon: 'phone',
        text: this.invoice.phone
      },
      {
        icon: 'email',
        text: this.invoice.email
      },
      {
        icon: 'place',
        text: this.address
      }
    ].filter((i) => i.text !== null)
  }
}
